export const dateValidator = /^(\d{2})\/(\d{2})\/(\d{4})$/;
export const nameSurnameValidator = /^[a-zA-Z-ąćęłńóśźżĄĆĘŁŃÓŚŹŻ ]+$/;
export const peselValidator = /^(\d{11})$/;
export const peselValidatorOptional = /^(___________)|(\d{11})$/;
export const postalCodePolandValidator = /^((\d{2})-(\d{3}))$/;
export const postalCodePolandValidatorOptional = /^(__-___)|((\d{2})-(\d{3}))$/;
export const postalCodeGenericValidatorOptional = /^[a-zA-Z0-9 -]{3,10}$/;
export const timeValidator = /^(\d{2}):(\d{2})$/;
export const regonValidator = /(^\d{9}$)|(^\d{14}$)/;
export const ocValidatorOptional = /^[a-zA-Z0-9]{0,30}$/;
export const ocValidator = /^[a-zA-Z0-9\/-]{0,30}$/;
export const startBracket = /(\[)/g;
export const endBracket = /(\])/g;
export const vinValidator = /^(?:(?![ioqIOQ])[a-zA-Z0-9]){17}$/;
export const yearValidator = /^\d{4}$/;
export const emailValidatorRegex = /^[^ąćęłńóśźżĄĆĘŁŃÓŚŹŻ]+$/;
